import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";

import { getApi } from "../../../../api/api";
import { OrderInterface } from "../../../../common/types/interfaces";

export const useOrderDetails = () => {
  const { id } = useParams<{ id: string }>();

  const [order, setOrder] = useState<OrderInterface | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getApi().getOrder(Number(id));
      setOrder(res);
    } catch {
      setOrder(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  return { order, ready: !loading };
};
